<template>
  <div class="contract-detail-bd" v-if="tabList.length">
    <div class="back-hd">
      <div class="back-fl">
        <i class="icon icon-fanhuijiantou" @click="jump($route.query.parentPath, {}, true)"></i>
        <span class="label" v-if="bizClassType === 'contract'">{{ $t('crm_contract_detail.he_tong_bian_hao') }}：{{ contractDetail.contractNo }}</span>
        <span class="label" v-if="bizClassType === 'order'">{{ $t('crm_contract_detail.ding_dan_bian_hao') }}：{{ contractDetail.contractNo }}</span>
      </div>
      <div class="back-fr">
        <div class="handle">
          <el-dropdown
            v-if="
              (approveAuth.includes('APPROVE') && contractHandle.verify && funcView.contractDetail_verify) ||
              // (contractHandle.printDelivery && funcView.contractDetail_printDelivery) ||
              // (contractHandle.factorySend && contractDetail.isNeedHqShip && funcView.contractDetail_factorySend) ||
              // (contractHandle.aftersaleSend && contractDetail.isNeedScShip && funcView.contractDetail_aftersaleSend) ||
              (contractHandle.partybReceive && funcView.contractDetail_partybReceive) ||
              (contractHandle.printConfirmation && funcView.contractDetail_printConfirmation) ||
              (contractHandle.changeSalesman && funcView.contractDetail_changeSalesman) ||
              (contractHandle.dateEndContinue && funcView.contractDetail_dateEndContinue) ||
              (contractHandle.tryToUse && funcView.contractDetail_tryToUse) ||
              (contractHandle.tryToOrder && funcView.contractDetail_tryToOrder && $store.state.userInfo.rootOrgId === contractDetail.partyAId)
            "
            @command="onContractHandle"
            style="vertical-align: top"
          >
            <el-button>
              <span>{{ $t('Common.com_more_action') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <!--
              审批 verify contractDetail_verify
              修改负责人（删除）changeHead-----删掉了
              缺方法 打印发货单 contractDetail_printDelivery
              总部发货 contractDetail_factorySend
              售后发货 （注：设备列表中）contractDetail_aftersaleSend
              租赁方收货 contractDetail_partybReceive
              售后收货 contractDetail_aftersaleReceive----删掉了
              缺方法 打印租赁确认单 contractDetail_printConfirmation
              启租（注：设备列表中）contractDetail_start
              期末续机 contractDetail_dateEndContinue
              试用转租赁 contractDetail_tryToUse
              试用转协议 contractDetail_tryToOrder

              本次不上线功能@林文波
              1.期末续租（更多操作）
              2.试用转租赁（更多操作）
              3.终止合同（变更）
              4.变更支付周期（变更）
              5.暂停使用（变更）

             -->
            <!-- 合同操作 -->
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="approval" v-if="funcView.contractDetail_verify && contractHandle.verify && approveAuth.includes('APPROVE')">
                {{ funcView.contractDetail_verify }}
              </el-dropdown-item>
              <!-- <el-dropdown-item command="printDelivery" v-if="contractHandle.printDelivery && funcView.contractDetail_printDelivery">{{ funcView.contractDetail_printDelivery }}</el-dropdown-item> -->
              <!-- <el-dropdown-item command="factorySend" v-if="contractHandle.factorySend && contractDetail.isNeedHqShip && funcView.contractDetail_factorySend">
                {{ funcView.contractDetail_factorySend }}
              </el-dropdown-item> -->
              <!-- <el-dropdown-item command="aftersaleSend" v-if="contractHandle.aftersaleSend && contractDetail.isNeedScShip && funcView.contractDetail_aftersaleSend">
                {{ funcView.contractDetail_aftersaleSend }}
              </el-dropdown-item> -->
              <el-dropdown-item command="partybReceive" v-if="contractHandle.partybReceive && funcView.contractDetail_partybReceive">{{ funcView.contractDetail_partybReceive }}</el-dropdown-item>
              <el-dropdown-item command="printConfirmation" v-if="contractHandle.printConfirmation && funcView.contractDetail_printConfirmation">
                {{ funcView.contractDetail_printConfirmation }}
              </el-dropdown-item>
              <el-dropdown-item command="changeSalesman" v-if="contractHandle.changeSalesman && funcView.contractDetail_changeSalesman">
                {{ funcView.contractDetail_changeSalesman }}
              </el-dropdown-item>
              <el-dropdown-item command="date_end_continue" v-if="contractHandle.dateEndContinue && funcView.contractDetail_dateEndContinue">
                {{ funcView.contractDetail_dateEndContinue }}
              </el-dropdown-item>
              <el-dropdown-item command="test_to_rent" v-if="contractHandle.tryToUse && funcView.contractDetail_tryToUse">{{ funcView.contractDetail_tryToUse }}</el-dropdown-item>
              <el-dropdown-item command="test_to_order" v-if="contractHandle.tryToOrder && funcView.contractDetail_tryToOrder">{{ funcView.contractDetail_tryToOrder }}</el-dropdown-item>
              <!-- contractHandle.firstpay <el-dropdown-item command="firstpay" v-if="contractHandle.firstpay">{{ $t('page_contract_xgsfk') }} </el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 合同变更 -->
          <el-dropdown
            v-if="
              Object.keys(contractChange).length &&
              (funcView.contractDetail_stop_contract ||
                funcView.contractDetail_stop_test ||
                funcView.contractDetail_stop_device_rent ||
                funcView.contractDetail_stop_device_sale ||
                funcView.contractDetail_replace_device ||
                funcView.contractDetail_replace_sale_device ||
                funcView.contractDetail_rent_time ||
                funcView.contractDetail_after_service ||
                funcView.contractDetail_pause_use ||
                funcView.contractDetail_payment_period)
            "
            @command="onChangeHandle"
            style="vertical-align: top; margin-left: 8px"
          >
            <el-button type="primary">
              <span class="label" v-if="bizClassType === 'contract'">{{ $t('crm_contract_detail.he_tong_bian_geng') }}</span>
              <span class="label" v-if="bizClassType === 'order'">{{ $t('crm_contract_detail.ding_dan_bian_geng') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <!--
              终止合同 contractDetail_stop_contract
              终止试用 contractDetail_stop_test
              终止设备租赁 contractDetail_stop_device_rent
              终止设备售卖 contractDetail_stop_device_sale
              更换设备 contractDetail_replace_device
              更换销售设备 contractDetail_replace_sale_device
              变更启租日期 contractDetail_rent_time
              变更售后公司 contractDetail_after_service
              暂停使用 contractDetail_pause_use
              变更支付周期 contractDetail_payment_period
              恢复使用（注：设备列表中） contractDetail_resume_use
             -->
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="stop_contract" v-if="contractChange.stop_contract && funcView.contractDetail_stop_contract">{{ funcView.contractDetail_stop_contract }}</el-dropdown-item> -->
              <el-dropdown-item command="stop_test" v-if="contractChange.stop_test && funcView.contractDetail_stop_test">{{ funcView.contractDetail_stop_test }}</el-dropdown-item>
              <el-dropdown-item command="stop_device_rent" v-if="contractChange.stop_device_rent && funcView.contractDetail_stop_device_rent">
                {{ funcView.contractDetail_stop_device_rent }}
              </el-dropdown-item>
              <el-dropdown-item command="stop_device_sale" v-if="contractChange.stop_device_sale && funcView.contractDetail_stop_device_sale">
                {{ funcView.contractDetail_stop_device_sale }}
              </el-dropdown-item>
              <el-dropdown-item command="change_device" v-if="contractChange.device && funcView.contractDetail_replace_device">{{ funcView.contractDetail_replace_device }}</el-dropdown-item>
              <el-dropdown-item command="change_sale_device" v-if="contractChange.change_sale_device && funcView.contractDetail_replace_sale_device">
                {{ funcView.contractDetail_replace_sale_device }}
              </el-dropdown-item>
              <el-dropdown-item command="rent_time" v-if="contractChange.rent_time && funcView.contractDetail_rent_time">{{ funcView.contractDetail_rent_time }}</el-dropdown-item>
              <el-dropdown-item command="after_service" v-if="contractChange.after_service && funcView.contractDetail_after_service">{{ funcView.contractDetail_after_service }}</el-dropdown-item>
              <el-dropdown-item command="pause_use" v-if="contractChange.pause_use && funcView.contractDetail_pause_use">{{ funcView.contractDetail_pause_use }}</el-dropdown-item>
              <el-dropdown-item command="payment_period" v-if="contractChange.payment_period && funcView.contractDetail_payment_period">{{ funcView.contractDetail_payment_period }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="contract-about ub">
      <div class="ub-f1">
        <div class="company">
          <ul class="ub">
            <li>
              <h1>
                <i class="icon icon-gongsi" style="color: #0d9ae0"></i>
                <span>{{ $t('crm_contract_detail.jia_fang') }}</span>
              </h1>
              <p>{{ contractDetail.partyAName }}</p>
            </li>
            <li>
              <h1>
                <i class="icon icon-gongsi" style="color: #0d9ae0"></i>
                <span>{{ $t('crm_contract_detail.yi_fang') }}</span>
              </h1>
              <p>{{ contractDetail.customerName }}</p>
            </li>
            <li>
              <h1>
                <i class="icon icon-kaigongsi" style="color: #16d071"></i>
                <span>{{ $t('crm_contract_detail.shou_hou_gong_si') }}</span>
              </h1>
              <p>{{ contractDetail.afterServiceName }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="company-aside">
        <div class="ub">
          <div class="item">
            <h2>
              <span v-if="bizClassType === 'contract'">{{ $t('crm_contract_detail.he_tong_lei_xing') }}</span>
              <span v-if="bizClassType === 'order'">{{ $t('crm_contract_detail.ding_dan_lei_xing') }}</span>
            </h2>
            <p v-if="contractClass == '40'">{{ typeDic[contractDetail.orderType] }}</p>
            <p v-else>{{ typeDic[contractDetail.bizClass] }}</p>
          </div>
          <div class="item">
            <h2>{{ $t('Common.com_status') }}</h2>
            <p>{{ statusDic[contractDetail.bizState] }}</p>
          </div>
          <div class="item">
            <h2>{{ $t('crm_contract_detail.she_bei_shu_liang') }}</h2>
            <p>{{ contractDetail.deviceTotalNum }}&thinsp;{{ $t('crm_contract_detail.tai') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="contract-wrap ub">
      <!-- tab切换 -->
      <div class="ub-f1 ub-f0h">
        <div class="ubv">
          <custom-tab style="background-color: #ffffff" :list="tabList" v-model="tab"></custom-tab>
          <!-- 合同信息 -->
          <contract-info v-if="tab === 'tab1'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-info>
          <!-- 合同信息（框架协议） -->
          <contract-info-frame v-if="tab === 'tab11'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-info-frame>
          <!-- 合同信息（协议订单） -->
          <contract-info-frame-order v-if="tab === 'tab13'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-info-frame-order>
          <!-- 合同信息（试用订单） -->
          <contract-info-trail v-if="tab === 'tab14'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-info-trail>
          <!-- 合同信息（租售订单） -->
          <contract-info-sale v-if="tab === 'tab15'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-info-sale>
          <!-- 合同订单（仅框架协议有） -->
          <contract-order-frame v-if="tab === 'tab12'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-order-frame>
          <!-- 订单变更记录 -->
          <contract-change v-if="tab === 'tab2'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-change>
          <!-- 设备 -->
          <contract-device v-if="tab === 'tab3' && contractClass != '40'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-device>
          <contract-device-sale v-if="tab === 'tab3' && contractClass == '40'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-device-sale>
          <!-- 账款 -->
          <contract-bill v-if="tab === 'tab4'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-bill>
          <!-- 发货计划 -->
          <contract-send-plan v-if="tab === 'tab7'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-send-plan>
          <!-- 发货记录 -->
          <contract-deliver v-if="tab === 'tab5'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-deliver>
          <!-- 赠送配件 -->
          <contract-giveaway v-if="tab === 'tab20'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-giveaway>
          <!-- 物流记录 -->
          <contract-logistics v-if="tab === 'tab6'" :detail="contractDetail" :rule="contractHandle" @success="onSuccess"></contract-logistics>
        </div>
      </div>
      <!-- 合同动态 -->
      <div v-if="funcView.contractDetail_tabDynamics">
        <div class="wrap-aside">
          <div class="aside-title">
            <span v-if="bizClassType === 'contract'">{{ $t('crm_contract_detail.he_tong_dong_tai') }}</span>
            <span v-if="bizClassType === 'order'">{{ $t('crm_contract_detail.ding_dan_dong_tai') }}</span>
          </div>
          <div class="flow">
            <ul>
              <li v-for="(item, index) in contractLog" :key="index">
                <div class="ub tit ub-xc">
                  <div class="dit1" :class="{ dit: index === 0 }">
                    <div></div>
                  </div>
                  <h1>{{ momentAmPm($momentLocal(item.operateTime)) }}</h1>
                </div>
                <div>
                  <p>{{ $t('crm_contract_detail.miao_shu') }}：{{ item.content }}</p>
                  <p>{{ $t('crm_contract_detail.cao_zuo_ren') }}：{{ item.userName }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 合同操作弹窗 -->
    <!-- 审批 -->
    <approval v-if="dialogVisible3 === 'approval'" :model="dialogModel3"  @close="dialogVisible3 = ''" @success="onSuccess"></approval>
    <!-- 总部发货 -->
    <factory-send
      v-if="dialogVisible3 === 'factorySend' && (contractClass != '40' || contractDetail.afterServiceId != contractDetail.partyAId)"
      :model="dialogModel3"
      @close="dialogVisible3 = ''"
      @success="onSuccess"
    ></factory-send>
    <!-- 总部发货（租售订单-甲方=售后） -->
    <factory-send-sale
      v-if="dialogVisible3 === 'factorySend' && contractClass == '40' && contractDetail.afterServiceId == contractDetail.partyAId"
      :model="dialogModel3"
      @close="dialogVisible3 = ''"
      @success="onSuccess"
    ></factory-send-sale>
    <!-- 乙方收货 -->
    <partyb-receive v-if="dialogVisible3 === 'partybReceive'" :model="dialogModel3" @close="dialogVisible3 = ''" @success="onSuccess"></partyb-receive>
    <!-- 售后发货 -->
    <aftersale-send
      v-if="dialogVisible3 === 'aftersaleSend' && (contractClass != '40' || contractDetail.afterServiceId != contractDetail.partyAId)"
      @close="dialogVisible3 = ''"
      :model="dialogModel3"
      @success="onSuccess"
    ></aftersale-send>
    <!-- 售后发货（租售订单-甲方=售后） -->
    <aftersale-send-sale
      v-if="dialogVisible3 === 'aftersaleSend' && contractClass == '40' && contractDetail.afterServiceId == contractDetail.partyAId"
      @close="dialogVisible3 = ''"
      :model="dialogModel3"
      @success="onSuccess"
    ></aftersale-send-sale>
    <!-- 变更首付款 -->
    <change-firstpay v-if="dialogVisible3 === 'firstpay'" @close="dialogVisible3 = ''" :model="dialogModel3" @success="onSuccess"></change-firstpay>
    <!-- 合同变更弹窗 -->
    <approval-dialog v-if="dialogVisible" :model="dialogModel" @success="onSuccess()" @close="dialogVisible = false"></approval-dialog>
    <!-- 打印租赁确认单第一步 选择设备 -->
    <contract-deviceSelect-dialog v-if="dialogVisible5" :model="dialogModel5" @close="dialogVisible5 = false"></contract-deviceSelect-dialog>
    <!-- 修改业务负责人 -->
    <contract-salesman-dialog v-if="dialogVisible7" :model="dialogModel7" @close="dialogVisible7 = false" @success="onSuccess"></contract-salesman-dialog>
  </div>
</template>

<script>
// tab切换
import apis from '@/utils/apis';
import contractRule from '@/utils/contractRule.js';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';
import contractDeviceSelectDialog from '@/pages/crm/components/contract_deviceSelect_dialog.vue';
import contractSalesmanDialog from '@/pages/crm/contractComponents/contract_salesman_dialog.vue';
import contractInfo from './children/contract_info.vue';
import contractInfoTrail from './children/contract_info_trail.vue';
import contractInfoFrame from './children/contract_info_frame.vue';
import contractInfoFrameOrder from './children/contract_info_frame_order.vue';
import contractInfoSale from './children/contract_info_sale.vue';
import contractOrderFrame from './children/contract_order_frame.vue';
import contractChange from './children/contract_change.vue';
import contractDevice from './children/contract_device.vue';
import contractGiveaway from './children/contract_giveaway.vue';
import contractDeviceSale from './children/contract_device_sale.vue';
import contractDeliver from './children/contract_deliver.vue';
import contractBill from './children/contract_bill.vue';
import contractSendPlan from './children/contract_send_plan.vue';
import contractLogistics from './children/contract_logistics.vue';
// 合同操作
import approval from '../contractHandle/contract_approval.vue';
import partybReceive from '../contractHandle/partyb_receive.vue';
import factorySend from '../contractHandle/factory_send.vue';
import factorySendSale from '../contractHandle/factory_send_sale.vue';
import aftersaleSend from '../contractHandle/aftersale_send.vue';
import aftersaleSendSale from '../contractHandle/aftersale_send_sale.vue';
import changeFirstpay from '../contractHandle/change_firstpay.vue';

export default {
  components: {
    contractInfo,
    contractInfoTrail,
    contractInfoFrame,
    contractInfoFrameOrder,
    contractInfoSale,
    contractOrderFrame,
    contractChange,
    contractDevice,
    contractGiveaway,
    contractDeviceSale,
    contractDeliver,
    contractBill,
    contractSendPlan,
    contractLogistics,
    approval,
    partybReceive,
    factorySend,
    factorySendSale,
    aftersaleSend,
    aftersaleSendSale,
    approvalDialog,
    changeFirstpay,
    contractDeviceSelectDialog,
    contractSalesmanDialog,
  },
  name: '',
  data() {
    return {
      typeDic: {},
      statusDic: {},
      approveAuth: [],
      tab: 'tab1',
      tabList: [],
      contractHandle: {},
      contractChange: {},

      contractId: '',
      contractClass: '',
      approveType: '',
      contractDetail: {},
      contractLog: [],

      dialogVisible: false,
      dialogVisible1: false,
      dialogModel: {},
      dialogModel1: {},
      dialogVisible2: false,

      dialogVisible3: false,
      dialogModel3: {},
      //  租赁确认单
      dialogVisible5: false,
      dialogModel5: {},
      //  修改业务负责人
      dialogVisible7: false,
      dialogModel7: {},
      // 字典 approval_type
      classMap: {
        trail_order: 10, // 试用订单
        leasing_contract: 20, // 租赁合同
        lease_renewal_contract: 21, // 续租租赁
        frame_contract: 30, // 框架协议
        frame_order: 31, // 协议订单
        lease_sales_order: 40, // 租售订单
      },
      approveMap: {
        10: 'trail_order', // 试用订单
        20: 'leasing_contract', // 租赁合同
        21: 'lease_renewal_contract', // 续租合同
        30: 'frame_contract', // 框架协议
        31: 'frame_order', // 协议订单
        40: 'lease_sales_order', // 租售订单
      },
      contractBizClass: ['20', '21', '30'], // 合同类型的bizClass
      orderBizClass: ['10', '31', '40'], // 订单类型的bizClass
      bizClassType: '', // 合同contract,订单order
      contractDeviceNum: 0,
    };
  },
  mounted: function () {
    this.contractId = this.getJump('contractId');
    this.contractClass = this.getJump('contractClass'); // 字典 crm_contract_type
    this.approveType = this.getJump('approveType');
    if (this.approveType && !this.contractClass) {
      this.contractClass = this.classMap[this.approveType];
    }
    if (!this.approveType && this.contractClass) {
      // E类购/新机购/租转售 都属于租售订单
      if (Number.parseInt(this.contractClass, 10) > 40 && Number.parseInt(this.contractClass, 10) < 50) {
        this.contractClass = 40;
      }
      this.approveType = this.approveMap[this.contractClass];
    }
    if (this.contractBizClass.includes(`${this.contractClass}`)) {
      this.bizClassType = 'contract';
    }
    if (this.orderBizClass.includes(`${this.contractClass}`)) {
      this.bizClassType = 'order';
    }
    this.getFuncView(null, () => {
      this.getContractDetail();
    });
    this.getDictionary('crm_contract_type,crm_contract_biz_state', (data) => {
      this.typeDic = this.$listTransObject(data.crm_contract_type);
      this.statusDic = this.$listTransObject(data.crm_contract_biz_state);
    });
    this.getContractLog();
    this.getApprove();
  },
  methods: {
    // 刷新合同状态
    refreshContractState() {
      this.getContractDetail();
    },
    // 预处理tab菜单
    formatTab: function () {
      //  20 租赁合同21 续租合同30 框架协议31 协议订单 10 试用订单
      //  合同信息 contractDetail_tabInfo
      //  发货计划 contractDetail_tabPlan
      //  合同变更 contractDetail_tabChange
      //  合同设备 contractDetail_tabDevice
      //  合同账款 contractDetail_tabAccounts
      //  发货记录 contractDetail_tabDelivery
      //  物流记录 contractDetail_tabLogistic
      //  合同信息框架协议  contractDetail_tabInfoFramework
      //  合同信息协议订单  contractDetail_tabAgreementOrder
      //  合同信息试用订单  contractDetail_tabTrialOrder
      //  合同订单框架协议  contractDetail_tabFrameworkOrder
      //  合同动态 contractDetail_tabDynamics

      // 框架协议(合同)
      if (`${this.contractClass}` === '30') {
        const tabList = [];
        if (this.funcView.contractDetail_tabInfoFramework) {
          tabList.push({ name: this.$t('crm_contract_detail.he_tong_xin_xi'), value: 'tab11' });
        }
        if (this.contractDetail.bizState >= 20) {
          if (this.funcView.contractDetail_tabFrameworkOrder) {
            tabList.push({ name: this.$t('crm_contract_detail.he_tong_ding_dan'), value: 'tab12' });
          }
          if (this.funcView.contractDetail_tabPlan) {
            tabList.push({ name: this.$t('crm_contract_detail.fa_huo_ji_hua'), value: 'tab7' });
          }
        }
        this.tabList = tabList;
        if (!['tab11', 'tab12', 'tab7'].includes(this.tab)) {
          this.tab = tabList[0] ? tabList[0].value : '';
        }
        return;
      }
      // 租赁合同、续租合同（合同）
      if (`${this.contractClass}` === '20' || `${this.contractClass}` === '21') {
        const tabList = [];
        if (this.funcView.contractDetail_tabInfo) {
          tabList.push({ name: this.$t('crm_contract_detail.he_tong_xin_xi'), value: 'tab1' });
        }
        if (this.funcView.contractDetail_tabDevice) {
          tabList.push({ name: this.$t('crm_contract_detail.she_beio', [this.contractDeviceNum]), value: 'tab3' });
        }
        if (this.funcView.contractDetail_tabGiveaway) {
          tabList.push({ name: this.$t('crm_contract_detail.zeng_song_pei_jian'), value: 'tab20' });
        }
        if (this.contractDetail.bizState >= 20) {
          if (this.funcView.contractDetail_tabChange) {
            tabList.push({ name: this.$t('crm_contract_detail.htbgjl'), value: 'tab2' });
          }
          if (this.funcView.contractDetail_tabAccounts) {
            tabList.push({ name: this.$t('crm_contract_detail.zhang_kuan'), value: 'tab4' });
          }
          if (this.funcView.contractDetail_tabPlan) {
            tabList.push({ name: this.$t('crm_contract_detail.fa_huo_ji_hua'), value: 'tab7' });
          }
          if (this.funcView.contractDetail_tabDelivery) {
            tabList.push({ name: this.$t('crm_contract_detail.fa_huo_ji_lu'), value: 'tab5' });
          }
          if (this.funcView.contractDetail_tabLogistic) {
            tabList.push({ name: this.$t('crm_contract_detail.wu_liu_ji_lu'), value: 'tab6' });
          }
        }
        this.tabList = tabList;
        if (!['tab1', 'tab2', 'tab3', 'tab4', 'tab5', 'tab6', 'tab7'].includes(this.tab)) {
          this.tab = tabList[0] ? tabList[0].value : '';
        }
        return;
      }
      // 协议订单（订单）
      if (`${this.contractClass}` === '31') {
        const tabList = [];
        if (this.funcView.contractDetail_tabAgreementOrder) {
          tabList.push({ name: this.$t('crm_contract_detail.ding_dan_xin_xi'), value: 'tab13' });
        }
        if (this.funcView.contractDetail_tabDevice) {
          tabList.push({ name: this.$t('crm_contract_detail.she_beio', [this.contractDeviceNum]), value: 'tab3' });
        }
        if (this.funcView.contractDetail_tabGiveaway) {
          tabList.push({ name: this.$t('crm_contract_detail.zeng_song_pei_jian'), value: 'tab20' });
        }
        if (this.contractDetail.bizState >= 20) {
          if (this.funcView.contractDetail_tabChange) {
            tabList.push({ name: this.$t('crm_contract_detail.ddbgjl'), value: 'tab2' });
          }
          if (this.funcView.contractDetail_tabAccounts) {
            tabList.push({ name: this.$t('crm_contract_detail.zhang_kuan'), value: 'tab4' });
          }
          if (this.funcView.contractDetail_tabPlan) {
            tabList.push({ name: this.$t('crm_contract_detail.fa_huo_ji_hua'), value: 'tab7' });
          }
          if (this.funcView.contractDetail_tabDelivery) {
            tabList.push({ name: this.$t('crm_contract_detail.fa_huo_ji_lu'), value: 'tab5' });
          }
          if (this.funcView.contractDetail_tabLogistic) {
            tabList.push({ name: this.$t('crm_contract_detail.wu_liu_ji_lu'), value: 'tab6' });
          }
        }
        this.tabList = tabList;
        if (!['tab13', 'tab2', 'tab3', 'tab4', 'tab5', 'tab6', 'tab7'].includes(this.tab)) {
          this.tab = tabList[0] ? tabList[0].value : '';
        }
        return;
      }
      // 试用订单（订单）
      if (`${this.contractClass}` === '10') {
        const tabList = [];
        if (this.funcView.contractDetail_tabTrialOrder) {
          tabList.push({ name: this.$t('crm_contract_detail.ding_dan_xin_xi'), value: 'tab14' });
        }
        if (this.funcView.contractDetail_tabDevice) {
          tabList.push({ name: this.$t('crm_contract_detail.she_beio', [this.contractDeviceNum]), value: 'tab3' });
        }
        if (this.funcView.contractDetail_tabAccounts) {
          tabList.push({ name: this.$t('crm_contract_detail.zhang_kuan'), value: 'tab4' });
        }
        if (this.contractDetail.bizState >= 20) {
          if (this.funcView.contractDetail_tabChange) {
            tabList.push({ name: this.$t('crm_contract_detail.ddbgjl'), value: 'tab2' });
          }
          if (this.funcView.contractDetail_tabPlan) {
            tabList.push({ name: this.$t('crm_contract_detail.fa_huo_ji_hua'), value: 'tab7' });
          }
          if (this.funcView.contractDetail_tabDelivery) {
            tabList.push({ name: this.$t('crm_contract_detail.fa_huo_ji_lu'), value: 'tab5' });
          }
          if (this.funcView.contractDetail_tabLogistic) {
            tabList.push({ name: this.$t('crm_contract_detail.wu_liu_ji_lu'), value: 'tab6' });
          }
        }
        this.tabList = tabList;
        if (!['tab14', 'tab2', 'tab3', 'tab5', 'tab6', 'tab7'].includes(this.tab)) {
          this.tab = tabList[0] ? tabList[0].value : '';
        }
      }
      // 租售订单
      if (`${this.contractClass}` === '40') {
        const tabList = [];
        if (this.funcView.contractDetail_tabInfo) {
          tabList.push({ name: this.$t('crm_contract_detail.ding_dan_xin_xi'), value: 'tab15' });
        }
        if (this.funcView.contractDetail_tabDevice) {
          tabList.push({ name: this.$t('crm_contract_detail.she_beio', [this.contractDeviceNum]), value: 'tab3' });
        }
        if (this.contractDetail.bizState >= 20) {
          if (this.funcView.contractDetail_tabChange) {
            tabList.push({ name: this.$t('crm_contract_detail.htbgjl'), value: 'tab2' });
          }
          if (this.funcView.contractDetail_tabAccounts) {
            tabList.push({ name: this.$t('crm_contract_detail.zhang_kuan'), value: 'tab4' });
          }
          if (this.funcView.contractDetail_tabPlan) {
            tabList.push({ name: this.$t('crm_contract_detail.fa_huo_ji_hua'), value: 'tab7' });
          }
          if (this.funcView.contractDetail_tabDelivery) {
            tabList.push({ name: this.$t('crm_contract_detail.fa_huo_ji_lu'), value: 'tab5' });
          }
          if (this.funcView.contractDetail_tabLogistic) {
            tabList.push({ name: this.$t('crm_contract_detail.wu_liu_ji_lu'), value: 'tab6' });
          }
        }
        this.tabList = tabList;
        if (!['tab15', 'tab2', 'tab3', 'tab4', 'tab5', 'tab6', 'tab7'].includes(this.tab)) {
          this.tab = tabList[0] ? tabList[0].value : '';
        }
      }
    },
    // 是否可以审批
    getApprove: function () {
      this.$postJSON(apis.apsApproveGetApproveAuth, {
        bizId: this.contractId,
        type: this.approveType,
      }).then((res) => {
        this.approveAuth = res.data || [];
      });
    },
    // 获取合同详情
    getContractDetail: function () {
      this.$getJSON(apis.contractInfo, {
        bizId: this.contractId,
        bizClass: this.contractClass,
      }).then((res) => {
        const detail = res.data;
        // this.formatAttachList(detail);
        this.contractControl(detail);
        this.contractDetail = detail;
        this.contractDeviceNum = detail.contractDeviceNum || 0;
        this.formatTab();
      });
    },
    // 合同资源分组
    // formatAttachList: function (detail) {
    //   if (detail.attachList) {
    //     detail.attachList = detail.attachList
    //       .filter(f => f.bizType === 'contractPhotocopy')
    //       .map(t => ({
    //         name: t.attachName,
    //         url: t.attachPath,
    //         type: t.bizType
    //       }));
    //     detail.firstPayPic = detail.attachList.find(t => t.bizType === 'prepaymentVoucher') || '';
    //   }
    // },
    // 合同变更控制
    contractControl: function (detail) {
      const contractRoles = this.getCurContractRole(detail);
      this.contractHandle = this.contractAuthControl(contractRule.handleRules, detail.bizClass, detail.bizState, contractRoles);
      this.contractChange = this.contractAuthControl(contractRule.changeRules, detail.bizClass, detail.bizState, contractRoles);
    },
    // 合同控制（操作/变更）
    contractAuthControl: function (rules, bizClass, contractState, contractRoles) {
      const stateList = this.listFindOneChildren(rules, bizClass);
      const actionList = this.listFindOneChildren(stateList, contractState);
      const result = actionList.filter((t) => contractRoles.find((f) => t.roleCode && t.roleCode.includes(f)));
      const data = {};
      result.forEach((item) => {
        data[item.value] = true;
      });
      return data;
    },
    // 获取当前账号合同担任角色
    getCurContractRole: function (detail) {
      const userInfo = this.$store.state.userInfo;
      const rootOrgId = userInfo ? userInfo.rootOrgId : ''; // 当前账户组织
      const contractRoles = []; // 当前用户在合同中担任角色列表
      // 是否是总部
      if (userInfo && userInfo.bizType === 'HQ') {
        contractRoles.push('HQ');
      }
      if (`${rootOrgId}` === `${detail.partyAId}`) {
        contractRoles.push('JV');
      }
      if (`${rootOrgId}` === `${detail.afterServiceId}` || (detail.afterServiceIdSet && detail.afterServiceIdSet.includes(rootOrgId))) {
        contractRoles.push('SC');
      }
      if (`${rootOrgId}` === `${detail.customerId}`) {
        contractRoles.push('CS');
      }
      return contractRoles;
    },
    // 字典处理函数
    listFindOneChildren: function (list, value) {
      let result = [];
      const row = list.find((t) => `${t.value}` === `${value}`);
      if (row) {
        result = row.children || [];
      }
      return result;
    },
    // 获取合同动态
    getContractLog: function () {
      this.$getJSON(apis.ContractChangeLog, {
        bizId: this.contractId,
        bizClass: this.contractClass,
      }).then((res) => {
        this.contractLog = res.data;
      });
    },
    // 合同操作
    onContractHandle: function (showType) {
      if (showType === 'printConfirmation') {
        // 租赁确认单：租赁合同、续租合同、协议订单
        this.dialogModel5.title = this.$t('crm_contract_detail.xuan_ze_she_bei');
        this.dialogModel5.bizId = this.contractId;
        this.dialogModel5.bizClass = this.contractClass;
        //  20租赁合同lease 21续租合同lease 30框架协议 31协议订单order 10试用订单trial
        if (`${this.contractClass}` === '20' || `${this.contractClass}` === '21') {
          this.dialogModel5.type = 'lease';
        } else if (`${this.contractClass}` === '31') {
          this.dialogModel5.type = 'order';
        } else if (`${this.contractClass}` === '10') {
          this.dialogModel5.type = 'trial';
        }
        this.dialogVisible5 = true;
        return;
      }
      // 修改项目负责人
      if (showType === 'changeSalesman') {
        // 租赁确认单：租赁合同、续租合同、协议订单
        this.dialogVisible7 = true;
        this.dialogModel7.title = this.$t('crm_contract_detail.bjywfzr');
        this.dialogModel7.bizId = this.contractId;
        this.dialogModel7.bizClass = this.contractClass;
        this.dialogModel7.partyAId = this.contractDetail.partyAId;
        return;
      }
      // 期末续租
      if (showType === 'date_end_continue') {
        // 租赁合同20  续租合同21 框架订单31
        if (`${this.contractClass}` === '20' || `${this.contractClass}` === '21') {
          this.clearKeepAlive('leaseaManagementItemContinue');
          setTimeout(() => {
            this.jump('/contract/management/leasecontinueadd', {
              lastOrderId: this.contractDetail.bizId,
              oldContractId: this.contractId,
              oldContractClass: this.contractClass,
            });
          }, 500);
        }
        if (`${this.contractClass}` === '31') {
          this.clearKeepAlive('agreementOrderItemContinue');
          setTimeout(() => {
            this.jump('/contract/agreementOrder/continue', {
              lastOrderId: this.contractDetail.bizId,
              oldContractId: this.contractId,
              oldContractClass: this.contractClass,
            });
          }, 500);
        }
        return;
      }
      // 试用转租赁
      if (showType === 'test_to_rent') {
        this.clearTagByKeep('leaseaManagement_item_rent');
        this.jump('/contract/management/leaserentadd', {
          lastOrderId: this.contractDetail.bizId,
          oldContractId: this.contractId,
          oldContractClass: this.contractClass,
          orderType: 20,
          parentPath: '/contract/management',
        });
        return;
      }
      if (showType === 'test_to_order') {
        this.clearTagByKeep('leaseaManagement_item_rent');
        this.jump('/contract/agreementOrder/leaseaorderadd', {
          lastOrderId: this.contractDetail.bizId,
          oldContractId: this.contractId,
          oldContractClass: this.contractClass,
          orderType: 31,
          parentPath: '/contract/agreementOrder',
        });
        return;
      }
      if (showType === 'approval') {
        this.dialogModel3.title = this.$t('crm_contract_detail.shen_pi_he_tong');
      }
      if (showType === 'factorySend') {
        this.dialogModel3.title = this.$t('crm_contract_detail.zong_bu_fa_huo');
      }
      if (showType === 'aftersaleSend') {
        this.dialogModel3.title = this.$t('crm_contract_detail.shgsfh');
      }
      if (showType === 'partybReceive') {
        this.dialogModel3.title = this.$t('crm_contract_detail.zu_lin_fang_shou_huo');
      }
      if (showType === 'firstpay') {
        this.dialogModel3.title = this.$t('crm_contract_detail.bgsfk');
      }
      this.dialogModel3.data = this.contractDetail;
      this.dialogModel3.approveType = this.approveType;
      this.dialogModel3.contractClass = this.contractClass;
      this.dialogVisible3 = showType;
    },
    // 合同变更
    onChangeHandle: function (showType) {
      const dicMap = {
        change_device: 'change_order_device',
        change_sale_device: 'change_order_sale_device',
        stop_contract: 'change_order_stop_contract',
        rent_time: 'change_order_rent_time',
        after_service: 'change_order_after_service',
        pause_use: 'change_order_pause_use',
        stop_device_rent: 'change_order_stop_rent',
        stop_device_sale: 'change_order_stop_sale',
        stop_test: 'change_order_stop_test',
        payment_period: 'change_order_payment_period',
      };
      this.dialogModel.type = 'add';
      this.dialogModel.changeType = dicMap[showType];
      this.dialogModel.changeId = this.contractId;
      this.dialogModel.unlimited = !!this.funcView.contractDetail_rent_all_time;
      this.dialogModel.row = { contractClass: this.contractClass };
      this.dialogVisible = true;
    },
    // 打印合同
    downloadContract(row) {
      this.dialogVisible4 = true;
      this.dialogModel4.title = this.$t('crm_contract_detail.da_yin_fa_huo_dan');
      this.dialogModel4.bizId = row.bizId;
      this.dialogModel4.bizClass = row.bizClass;
      this.dialogModel4.type = 'lease';
      // this.dialogModel4.bizClass = '20';
      // this.dialogModel4.bizId = '521691420901617664';
      // this.dialogModel4.contractId = '521691420901617664';
    },
    // 打印租赁确认单
    downloadConfirmed(row) {
      this.dialogVisible5 = true;
      this.dialogModel5.title = this.$t('crm_contract_detail.xuan_ze_she_bei');
      this.dialogModel5.bizId = row.bizId;
      this.dialogModel5.bizClass = row.bizClass;
      this.dialogModel5.type = 'lease';
    },
    // 操作成功
    onSuccess: function () {
      this.getContractDetail();
      this.getContractLog();
      this.Bus.$emit('contract_detail');
      this.Bus.$emit('contractList');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.contract-detail-bd {
  height: 100%;
  .back-hd {
    padding: 24px 16px 16px;
    .back-fl {
      height: 32px;
      line-height: 32px;
      display: inline-block;
      .icon {
        color: #394668;
        font-size: 18px;
        font-weight: bold;
        margin-left: 4px;
        margin-right: 16px;
        cursor: pointer;
      }
      span {
        color: #394668;
        font-size: 18px;
        font-weight: 500;
      }
    }
    .back-fr {
      float: right;
    }
  }
  .contract-about {
    margin: 0 16px;
    padding: 19px 0;
    height: 88px;
    background-color: #ffffff;
    .name {
      padding-left: 20px;
      padding-top: 20px;
      height: 60px;
      .icon {
        font-size: 20px;
        line-height: 28px;
        margin-right: 16px;
      }
      h1 {
        font-size: 15px;
        color: $title-color;
        line-height: 28px;
        height: 28px;
        font-weight: bold;
      }
    }
    .company {
      padding-left: 20px;
      ul > li {
        min-width: 230px;
        height: 50px;
        padding-left: 24px;
        padding-right: 50px;
        border-right: 1px solid #e9ebec;
        &:last-child {
          border-right: none;
        }
        h1 {
          font-size: 12px;
          color: #495057;
          font-weight: 500;
          line-height: 26px;
          .icon {
            font-size: 18px;
            margin-right: 6px;
            float: left;
          }
        }
        p {
          line-height: 24px;
          color: #6c757d;
          font-size: 12px;
        }
      }
    }
    .company-aside {
      padding-right: 24px;
      .handle {
        padding: 20px 0 0 80px;
        height: 66px;
      }
      .item {
        text-align: right;
        margin-left: 50px;
        h2 {
          color: #6c757d;
          font-size: 12px;
          line-height: 18px;
          height: 18px;
          margin-bottom: 6px;
        }
        p {
          color: #495057;
          font-size: 16px;
          font-weight: 500;
          height: 26px;
          line-height: 26px;
        }
      }
    }
  }
  .contract-wrap {
    padding: 16px;
  }
  .wrap-aside {
    width: 350px;
    background-color: #ffffff;
    margin-left: 20px;
    padding-bottom: 10px;
    .aside-title {
      line-height: 40px;
      height: 40px;
      padding-left: 20px;
      color: #495057;
      font-weight: 500;
      font-size: 12px;
      border-bottom: 1px solid #eef2f8;
      margin-bottom: 10px;
    }
    .flow {
      padding: 25px 0 25px 32px;
      height: 760px;
      overflow-y: auto;
      .dit1.dit {
        background-color: #ffffff;
        padding: 5px;
        width: 20px;
        div {
          background-color: #4a90e2;
          width: 11px;
          height: 11px;
          border-radius: 7px;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 3px;
            top: 3px;
            z-index: 1;
            width: 5px;
            height: 5px;
            border-radius: 6px;
            background-color: #ffffff;
          }
        }
      }

      .dit1 {
        background-color: #ffffff;
        padding: 3px 6px;
        width: 20px;
        div {
          background-color: #8c8c8c;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          position: relative;
        }
      }
      ul > li {
        padding: 14px 20px 44px 23px;
        border-left: 1px solid #bfbfbf;
        position: relative;
        word-break: break-all;
        box-sizing: content-box;
        &:last-child {
          border-left: 1px solid #ffffff;
        }
        .tit {
          position: absolute;
          top: -12px;
          left: -11px;
        }
        h1 {
          color: #495057;
          font-size: 12px;
          line-height: 24px;
          margin-left: 14px;
          font-weight: 500;
        }
        p {
          font-size: 12px;
          color: #6c757d;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
